export default __webpack_public_path__ + "static/media/Roboto-Regular.cfe3602c.ttf";